import React, {useState, useContext, useEffect} from 'react';
import PropTypes from 'prop-types';

import {bipolarMoodTrackerScreenData} from './surveyConsts.js';

import Header from './Header.js';
import Disclaimers from './Disclaimers.js';
//import ConfirmDialog from './ConfirmDialog.js';
import ConfirmLoginState from './ConfirmLoginState.js';
import LogTwoPartHistory from './LogTwoPartHistory.js';

import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
//import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
//import Link from '@material-ui/core/Link';
//import CardMedia from '@material-ui/core/CardMedia'
//import CircularProgress from "@material-ui/core/CircularProgress";
//import List from '@material-ui/core/List';
//import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
//import ListItemText from '@material-ui/core/ListItemText';
import Snackbar from '@material-ui/core/Snackbar';

import firebase, {firestore, auth, signInWithGoogle} from './firebase.js'
import {UserContext} from './UserContext.js';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
        padding: 20,
        paddingTop:100,
        margin: 'auto',
      maxWidth: 800,
    },
    formCard: {
      padding: theme.spacing(2),
      textAlign: 'left',
      color: theme.palette.text.secondary,
        //margin: theme.spacing(2),
        alignItems: 'center',
    },
    card: {
        //padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
          //margin: theme.spacing(2),
          alignItems: 'center',
      }, 
      button: {
           padding: theme.spacing(2),
        margin: theme.spacing(1),
          alignItems: 'center',
          //width: 150,
      },
      cardContent: {
          paddingTop: theme.spacing(1),
          paddintBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
      },
      cardAction: {
        justifyContent: 'center',  
        alignItems: 'center',
         paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
      cardActionForm: {
        justifyContent: 'left', 
        //display:'flex',
        //flexGrow:1, 
         paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
      cardActionButton: {
        justifyContent: 'center',  
        alignItems: 'center',
         paddingTop: theme.spacing(0),
          paddingBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
      media: {
          //width: 100,
          //marginBottom: theme.spacing(4),
      },
      textField: {
          //textAlign: 'right',
          //marginRight:theme.spacing(1),
      },
      /*textForm: {
        textAlign: "left",
        //flexGrow: 1,
        //marginLeft:theme.spacing(1),
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },*/
      textList: {
        textAlign: "right",
      },
      text: {
        textAlign: "center",
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      textExplanation: {
        textAlign: "justify",
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      textForm: {
        textAlign: "justify",
        //maxWidth: 500,
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      select: {
        minWidth: 250,
        marginLeft: theme.spacing(3),
      }
  }));

  export default function LogTwoPartScreen (props) {
    const classes = useStyles();
    const {user, loading, error}= useContext(UserContext);
    const [showDataSaved, setShowDataSaved] = useState(false);
    
    
    // FIND DATA SOURCE BASED ON ITEM
    let data = {};
    if (props.item==="Bipolar-Tracker") {
        data = bipolarMoodTrackerScreenData;
    } 

    const {title, subTitle, instructions, sectionTitles, sectionSubTitles, dataTypes, tableDataTypes, graphDataTypes} = data;

    // USESTATES FOR SURVEYS FROM DATA
    const [surveyPartA, setSurveyPartA] = useState(data.surveys[0]);
    const [surveyPartB, setSurveyPartB] = useState(data.surveys[1]);

    //COMMENTS
    const [comments, setComments] = useState("");

    // UPDATE SURVEY DATA WHEN DATA CHANGES
    useEffect(()=>{
        setSurveyPartA(data.surveys[0]);
        setSurveyPartB(data.surveys[1]);
        //window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll up when data changes
      }, [data]); 


    function handleAnswerSurveyAClick(selectedQuestion, newChoice){
        const newSurveyA = surveyPartA.map((question)=>{
            return (question.text !== selectedQuestion.text) ? question : {text: question.text, answers: question.answers, choice: newChoice, explanation: question.explanation};
        });
        setSurveyPartA (newSurveyA);
    }
    
    function handleAnswerSurveyBClick(selectedQuestion, newChoice){
        const newSurveyB = surveyPartB.map((question)=>{
            return (question.text !== selectedQuestion.text) ? question : {text: question.text, answers: question.answers, choice: newChoice, explanation: question.explanation};
        });
        setSurveyPartB (newSurveyB);
    }

    function handleCommentsValueChange(event) {
      setComments(event.target.value);
  }

    function totalScore(survey) {
      let score = 0;
      survey.map((question)=>score+=question.choice);
      return score;
    }

    function phq9ScoreInterpretation (score) { // Depression Interpretation
      if (score >=20 ) {
        return "Severe Depression";
      } else if (score >= 15) {
        return "Moderately Severe Depression";
      } else if (score >=10) {
        return "Moderate Depression";
      } else if (score >= 5) {
        return "Mild Depression";
      } else {
        return "Minimal/No Depression";
      }
    }

    function asrmScoreInterpretation (score) { // Mania Interpretation
      if (score >= 6) {
        return "Mania/Hypomania Likely"
      } else {
        return "Mania/Hypomania Unlikely"
      }
    }

    function interpretation(dataType, score) { // Show interpretation based on data type and score
      if (dataType==="phq9Score") {
        return phq9ScoreInterpretation(score);
      } else if (dataType==="asrmScore") {
        return asrmScoreInterpretation(score);
      }
      return "";
    }

    function showScoreA() {
      return <>
      <CardContent className={classes.cardContent}>
          <Typography className={classes.textExplanation} color="inherit" variant="h6"><strong>Total: </strong>{totalScore(surveyPartA)}{", "}
          {interpretation(dataTypes[0], totalScore(surveyPartA))}
          </Typography>
      </CardContent>
      </>;
    }

    function showScoreB() {
      return <>
      <CardContent className={classes.cardContent}>
          <Typography className={classes.textExplanation} color="inherit" variant="h6"><strong>Total: </strong>{totalScore(surveyPartB)}{", "}
          {interpretation(dataTypes[1], totalScore(surveyPartB))}
          </Typography>
      </CardContent>
      </>;
    }

    //Show survey questions
    function showSurveyPartA() {
      return surveyPartA.map((question, index)=>{
      const menuItems = question.answers.map((answer, index)=><MenuItem value={index} key={answer}>{answer}</MenuItem>);

      return <React.Fragment key={question.text}>
        <CardContent className={classes.cardActionForm}>
          <Typography className={classes.textForm} color="inherit" variant="body1">{index+1}) {question.text}</Typography>
        </CardContent>
        <CardActions className={classes.cardActionForm} >
          <FormControl>
            <Select  className={classes.select} id="choices" value={question.choice} onChange={(e)=>handleAnswerSurveyAClick(question,e.target.value)} fullWidth>
              {menuItems}
            </Select>
          </FormControl>
      </CardActions>
      </React.Fragment>
      });
    }

    function showSurveyPartB() {
      return surveyPartB.map((question, index)=>{
        const menuItems = question.answers.map((answer, index)=><MenuItem value={index} key={answer}>{answer}</MenuItem>);
  
        return <React.Fragment key={question.text}>
          <CardContent className={classes.cardActionForm}>
            <Typography className={classes.textForm} color="inherit" variant="body1">{index+1}) {question.text}</Typography>
          </CardContent>
          <CardActions className={classes.cardActionForm} >
            <FormControl>
              <Select  className={classes.select} id="choices" value={question.choice} onChange={(e)=>handleAnswerSurveyBClick(question,e.target.value)} fullWidth>
                {menuItems}
              </Select>
            </FormControl>
        </CardActions>
        </React.Fragment>
        });
      }

      function handleResetClick() {
        setSurveyPartA(data.surveys[0]);
        setSurveyPartB(data.surveys[1]);
        setComments("");
      }

      // Manage Logins
      const googleSignIn = () => {
        //event.preventDefault();
        signInWithGoogle();
      }

      const signOut = (event) => {
          event.preventDefault();
          auth.signOut();
      }

      /// Manage Data
    const handleSaveSubmit = (event) => {
      event.preventDefault();
      firestore.collection("Users")
     .doc(user.uid)
     .collection(`${props.item.toLowerCase()}`)
     .doc(new Date().toString())
     .set({
         date: firebase.firestore.Timestamp.now(), 
         surveyPartAType: dataTypes[0],
         surveyPartAHeading: tableDataTypes[0].title,
         surveyPartATypeValue: tableDataTypes[0].type,
         surveyPartASuffix: tableDataTypes[0].suffix,
         surveyPartAScore: Number(totalScore(surveyPartA)),
         surveyPartAInterpretation: interpretation(dataTypes[0], totalScore(surveyPartA)),
         surveyPartACompleteData: surveyPartA,
         surveyPartBType: dataTypes[1],
         surveyPartBHeading: tableDataTypes[1].title,
         surveyPartBTypeValue: tableDataTypes[1].type,
         surveyPartBSuffix: tableDataTypes[1].suffix,
         surveyPartBScore: Number(totalScore(surveyPartB)),
         surveyPartBInterpretation: interpretation(dataTypes[1], totalScore(surveyPartB)),
         surveyPartBCompleteData: surveyPartB,
         comments: comments,
     })
      .then(() => {
          //console.log("Uploaded Data");
          setShowDataSaved(true);
          handleResetClick(); //Reset when uploaded
      });
  }
  
  const handleDataSavedClose  = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    if (event) {
      event.preventDefault();
    };
    setShowDataSaved(false);  
  };

    return <>
            <div className={classes.root}>
                <Header title={title} subTitle={subTitle} />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Card className={classes.formCard}>
                            <CardContent className={classes.cardContent}>
                                <Typography className={classes.textExplanation} color="inherit" variant="h4"><strong>Today's Log</strong></Typography>
                                <Typography className={classes.textExplanation} color="inherit">{instructions}</Typography>
                            </CardContent>
                            <Divider/>
                            <form onSubmit={handleSaveSubmit}> 
                            <CardActions className={classes.cardContent}> 
                                    <TextField className={classes.textField} fullWidth variant="outlined" id="comments" label="Comments" type="text" InputLabelProps={{shrink: true,}} value={comments} onChange={handleCommentsValueChange} placeholder="Today I feel...."/>
                            </CardActions>
                            <Divider/>
                            <CardContent className={classes.cardContent}>
                                <Typography className={classes.textExplanation} color="inherit" variant="h6"><strong>{sectionTitles[0]}</strong></Typography>
                                <Typography className={classes.textExplanation} color="inherit">{sectionSubTitles[0]}</Typography>
                            </CardContent>
                            {showSurveyPartA()}
                            {showScoreA()}
                            <Divider/>
                            <CardContent className={classes.cardContent}>
                                <Typography className={classes.textExplanation} color="inherit" variant="h6"><strong>{sectionTitles[1]}</strong></Typography>
                                <Typography className={classes.textExplanation} color="inherit">{sectionSubTitles[1]}</Typography>
                            </CardContent>
                            {showSurveyPartB()}
                            {showScoreB()}
                            <Divider/>
                            <ConfirmLoginState loading={loading} error={error} user={user} onSignIn={googleSignIn} onSignOut={signOut} explanationText={"To be able to save today's mood log you need to be logged in through your Google account."} displayFragment={
                            <CardActions className={classes.cardActionButton}>  
                                <Button className={classes.button} variant="contained" color="primary" name="submit" type="submit">Save Today's Log</Button>
                                <Button className={classes.button} variant="contained" color="primary" onClick={handleResetClick}>Reset</Button>
                            </CardActions>}/>
                            </form>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card className={classes.formCard}>
                            <CardContent className={classes.cardContent}>
                                <Typography className={classes.textExplanation} color="inherit" variant="h4"><strong>History</strong></Typography>
                                <Typography className={classes.textExplanation} color="inherit">Review past logs. Click on "..." for details</Typography>
                            </CardContent>
                            <ConfirmLoginState loading={loading} error={error} user={user} onSignIn={googleSignIn} onSignOut={signOut} explanationText={"To be able to view your history, you need to be logged in through your Google account."} displayFragment={<><LogTwoPartHistory user={user} item={props.item} tableDataTypes={tableDataTypes} graphDataTypes={graphDataTypes}/></>}/>                
                        </Card>
                    </Grid>
                </Grid>
                <Disclaimers />
                <Snackbar open={showDataSaved} autoHideDuration={3000} onClose={handleDataSavedClose} message="Data saved." action={<Button color="primary" onClick={handleDataSavedClose}>OK</Button>}/>
            </div>
            </>
  }

  LogTwoPartScreen.propTypes = {
      //children: PropTypes.node,
      item: PropTypes.any.isRequired, // Data is required
  };